import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bookmark, ArrowRight } from 'lucide-react';
import { api } from '../../lib/api';
import { SocialPostCard } from '../SocialPostCard';
import { useT } from '../../context/LanguageContext';

export const FavoriteVideos = () => {
  const { t } = useT();
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get('/users/me/favorites').then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  const update = (p) => setPosts((list) => (p.favorited ? list.map((x) => (x.id === p.id ? p : x)) : list.filter((x) => x.id !== p.id)));

  return (
    <div data-testid="favorites-card" className="rounded-3xl bg-[#0f0a17]/90 backdrop-blur-xl border border-white/10 p-7 md:p-9">
      <div className="flex items-center justify-between gap-3 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#ffb400]/15 text-[#ffb400] flex items-center justify-center"><Bookmark size={20} /></div>
          <h2 className="text-lg md:text-xl font-bold text-white">{t('Mine favorittar')}</h2>
        </div>
        <Link to="/videoar" className="inline-flex items-center gap-1 text-sm text-[#ff2e2e] font-bold hover:underline">{t('Alle videoar')} <ArrowRight size={14} /></Link>
      </div>
      {posts === null ? (
        <p className="text-white/50 text-sm">{t('Lastar…')}</p>
      ) : posts.length === 0 ? (
        <p data-testid="favorites-empty" className="text-white/50 text-sm">{t('Du har ikkje lagra nokon videoar enno. Trykk «Lagre» på ein video for å finne han att her.')}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-start" data-testid="favorites-grid">
          {posts.map((p) => <SocialPostCard key={p.id} post={p} onChange={update} onDelete={(id) => setPosts((l) => l.filter((x) => x.id !== id))} />)}
        </div>
      )}
    </div>
  );
};
